import React, { useEffect, useState } from "react";
import { dispatchStore } from "../lib/dispatchStore";
import { saleReportSlice } from "../helper/customSlice";

const DropdownFilter = ({
  dropdownItems,
  defaultValue,
  onSelect,
  placeholder,
  valueKey = "name",
  disabled = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  // console.log(dropdownItems, "dropdownItems");

  useEffect(() => {
    setSelectedValue("");
  }, [placeholder]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSelectedValue(newValue);

    const selectedItem = dropdownItems.find(
      (item) => item[valueKey]?.toString() === newValue
    );

    console.log(newValue, selectedItem, dropdownItems, "selectedItem .....");

    onSelect(selectedItem);
  };

  return (
    <div className={`relative`}>
      <select
        className="min-w-[140px] border-[1px] border-gray-300 rounded-md px-4 py-[5px] focus:ring-blue-500 focus:border-blue-500 focus:outline-none appearance-none"
        // value={selectedValue}
        value={selectedValue}
        onChange={handleChange}
      >
        <option value="">
          <span className="ml-4">{placeholder}</span>
        </option>
        {dropdownItems?.map((item, index) => (
          <option key={index} value={item[valueKey]}>
            {item?.name || item?.team_name}
          </option>
        ))}
      </select>
      <span className="absolute inset-y-0 right-1 flex items-center pointer-events-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-3"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </span>
    </div>
  );
};

export default DropdownFilter;
